<div #positionFixedOffset class="position-fixed-offset"></div>
<ng-content></ng-content>
<ng-container #viewContainer></ng-container>
